import React from "react";
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import App from "./App";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Resume from "./components/Resume/Resume";
import ErrorPage from "./components/ErrorPage";
import "./index.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App component={<Home/>} />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/about",
    element: <App component={<About/>} />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/project",
    element: <App component={<Projects/>} />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/resume",
    element: <App component={<Resume/>} />,
    errorElement: <ErrorPage />,
  },
  {
    path: "*",
    element: <App component={<ErrorPage/>} />,
    errorElement: <ErrorPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);